import { FC, useContext } from 'react'
import { sum } from '../../../../lib/Calculator'
import { BudgetContext } from '../../../../lib/Context'
import { useFormatCurrency } from '../../../../lib/CurrencyFormatter'
import { generateIdForItem } from '../../../../lib/IdGenerator'
import { SheetCategory, Spend } from '../../../../lib/Types'
import { SpendFrequency } from '../../lib/Enums/SpendFrequency'
import ReconciliationSpend from './ReconciliationSpend'

interface Props {
  category: SheetCategory
  spends: Spend[]
}

const ReconciliationSpends: FC<Props> = ({ category, spends }) => {
  const formatCurrency = useFormatCurrency()
  const { reconciliationYear } = useContext(BudgetContext)
  return (
    <>
      <table
        className={'min-w-full table-budget col-3'}
      >
        <tbody>
          <tr className='bg-gray-100 border-b border-x border-gray-300'>
            <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>
              <div className='flex items-center justify-between'>
                {category.name}
              </div>
            </th>
            <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>
              {formatCurrency(sum(spends, SpendFrequency.YEARLY))}
            </th>
            <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>
            </th>
          </tr>
        </tbody>
      </table>
      <table
        className={'min-w-full table-budget col-3'}
      >
        <tbody>
          {spends.map((spend) => (
            <ReconciliationSpend key={`${generateIdForItem(spend)}-${reconciliationYear}`} spend={spend} />
          ))}
        </tbody>
      </table>
    </>
  )
}

export default ReconciliationSpends
